// import { Autocomplete, Button, Checkbox, Chip, TextField } from '@mui/material'
import React, { useEffect } from 'react'
import { Button, Checkbox, Chip, TextField, Typography } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import { useStyles } from './styles'

const MultiSelect = ({
    options,
    selected,
    label,
    handleChange,
    handleSelectOne,
    style
}) => {
    const classes = useStyles()
    const isSelected = ({ id }) =>
        selected.some((objeto) =>
            (objeto.id === id)
        )

    useEffect(() => {

    }, [selected])
    return (
        <Autocomplete
            multiple
            options={[{ nombre: 'Todos', id: 'all' }, ...options]}
            className={classes.filterMonths}
            getOptionLabel={option => option.nombre}
            value={selected}
            style={style}
            // openOnFocus
            onChange={(e, newValue) => handleChange({ value: newValue })}
            renderInput={params => <TextField {...params} label={label} variant='outlined' />}
            renderTags={(value, getTagProps) =>
                <div className={classes.containerChipsScroll}>
                    {
                        selected.map((option, index) => (
                            <Chip
                                key={option}
                                label={
                                    option === 'all'
                                        ? 'Todos'
                                        : option.nombre
                                }
                                {...getTagProps({ index })}
                            />
                        ))
                    }
                </div>
            }
            renderOption={(option) => (
                <div className={classes.optionAutocomplete}>
                    <Checkbox
                        style={{ marginRight: 8 }}
                        color='primary'
                        checked={isSelected({ id: option.id })}
                    />
                    <Typography style={{ maxWidth: '160px', margin: 0 }}>{option.nombre}</Typography>
                    <Button
                        variant='outlined'
                        style={{
                            position: 'absolute',
                            right: 12,
                        }}
                        color='primary'
                        onClick={e =>
                            handleSelectOne({ event: e, value: option })
                        }
                    >
                        Solamente
                    </Button>
                </div >
            )}
        />
    )
}

export default MultiSelect
